module.exports = __webpack_public_path__ + "static/media/skill_ts.80bee428.jpeg";